var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgStomach = function SvgStomach(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 64 64"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#83E3ED",
    d: "M32.383 5.621c14.36 0 26 11.64 26 26s-11.64 26-26 26-26-11.64-26-26 11.64-26 26-26"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#008C95",
    d: "M23.34 37.2H16.4v-1.74a1.741 1.741 0 0 0-3.48 0v1.74H6v-1.74c0-4.78 3.88-8.66 8.66-8.66s8.66 3.88 8.66 8.66v1.74zM32.86 23.34h-2.6c-5.74 0-10.4-4.66-10.4-10.4V9.48h6.94v3.46c0 1.92 1.56 3.46 3.46 3.46h2.6z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#00686A",
    d: "M19.86 9.46h3.46v3.46c0 3.82 3.1 6.94 6.94 6.94h2.6v3.46h-2.6c-5.74 0-10.4-4.66-10.4-10.4z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#008C95",
    d: "M44.138 9.461c7.66 0 13.86 6.2 13.86 13.86v6.94c0 13.4-10.86 24.26-24.26 24.26-9.58 0-17.34-7.76-17.34-17.34h6.94c3.82 0 6.94-3.1 6.94-6.94v-6.94c0-7.66 6.2-13.86 13.86-13.86z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#00686A",
    d: "M51.058 16.402c-3.82 0-6.94 3.1-6.94 6.94v10.4c0 5.74-4.66 10.4-10.4 10.4h-6.94c-3.82 0-6.94-3.1-6.94-6.94v-1.74c0-2.88-2.32-5.2-5.2-5.2a5.19 5.19 0 0 0-5.2 5.2v1.74h3.46v-1.74a1.741 1.741 0 0 1 3.48 0v1.74c0 9.58 7.76 17.34 17.34 17.34 13.4 0 24.26-10.86 24.26-24.26v-6.94c0-3.82-3.1-6.94-6.94-6.94z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#F04B24",
    d: "M23.34 40.66h-3.02c1.54 5.98 6.98 10.4 13.42 10.4h.1c7.66 0 14.38-4.2 17.94-10.4z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#E1F8FA",
    d: "M33.743 31.142c-.48 0-.86-.38-.86-.86v-6.94c0-6.22 5.06-11.26 11.26-11.26.48 0 .86.38.86.86s-.38.86-.86.86c-5.26 0-9.54 4.28-9.54 9.54v6.94c0 .48-.38.86-.86.86"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#FC9179",
    d: "M29.84 48.46a2.16 2.16 0 1 0 0-4.32 2.16 2.16 0 0 0 0 4.32M34.602 44.122a.86.86 0 1 0 0-1.72.86.86 0 0 0 0 1.72M41.676 47.603a1.02 1.02 0 1 0 0-2.04 1.02 1.02 0 0 0 0 2.04"
  })));
};
export default SvgStomach;